import React from 'react';
import {
  FDBox,
  FDHeadlineText, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TimelineMonthGroup from 'Components/ComponentLibrary/Organisms/Timeline/TimelineMonthGroup';
import useMobileLayout from 'Hooks/useMobileLayout';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import fr from 'facet-rest';
import { DataValueMap } from 'Helpers/Testing';
import TimelineConnector from './TimelineConnector';

const useStyles = makeStyles(theme => ({
  yearBorder: {
    borderColor: theme.palette.facet.oceana800,
    borderWidth: '1px',
    margin: theme.spacing(1, 0, 1, 0),
    padding: theme.spacing(0.5, 2.5),
    borderRadius: theme.radius.md,
    borderStyle: 'solid',
  },
}));


export default function TimelineYearGroup({
  yearGroupResource, timelineCardComponent, isFirstItem, isLastItem,
}) {
  const theme = useTheme();
  const isMobile = useMobileLayout();
  const classes = useStyles(theme);
  const timelineMonthGroups = yearGroupResource.attr('timelineMonthGroups')?.resources().list() || [];
  const timelineMonthGroupsLength = yearGroupResource.attr('timelineMonthGroups')?.resources().length() || 0;

  return (
    <FDBox alignSelf={'center'}>
      <FDStack direction={'row'}>
        {!isMobile && <FDStack minWidth={'120px'} /> }
        <FDStack width={'100%'} justifyContent={isMobile ? 'center' : 'flex-start'}>
          <Box
            className={classes.yearBorder}
            {...DataValueMap.init('timeline-year').build()}
          >
            <FDHeadlineText size={'lg'} value={yearGroupResource.attr('year')} />
          </Box>
        </FDStack>
      </FDStack>
      {
        timelineMonthGroups.map(((monthGroup, monthGroupIdx) => {
          return (<TimelineMonthGroup
            monthGroupResource={monthGroup}
            timelineCardComponent={timelineCardComponent}
            key={`${yearGroupResource.attr('year')}-${monthGroup.attr('month')}`}
            isFirstItem={isFirstItem && monthGroupIdx === 0}
            isLastItem={isLastItem && monthGroupIdx === timelineMonthGroupsLength - 1}
          />);
        }))
      }
      {!isLastItem && isMobile && (
      <FDStack direction={'row'} justifyContent={'center'}>
        <TimelineConnector />
      </FDStack>
      )}
    </FDBox>
  );
}

TimelineYearGroup.defaultProps = {
  isFirstItem: false,
  isLastItem: false,
};

TimelineYearGroup.propTypes = {
  yearGroupResource: PropTypes.instanceOf(fr.Resource).isRequired,
  timelineCardComponent: PropTypes.element.isRequired,
  isFirstItem: PropTypes.bool,
  isLastItem: PropTypes.bool,
};
